module.exports = __webpack_public_path__ + "img/pharmaceutical.755e0883.png";